import { useDispatch } from 'react-redux';
import _merge from 'lodash/merge';

import { useMaybeHandleCriticalError } from 'react-redux-app/lib/modules/api/hooks';
import { useUri } from 'react-redux-app/lib/modules/routing/hooks';

import { isGlobalErrorsMatchesList, convertGlobalErrors } from '../errorUtils';

import { actionAddGlobalError } from 'react-redux-app/lib/modules/globalError/actions';


export default () => {
  const dispatch = useDispatch();

  const currentUri = useUri();

  const maybeHandleCriticalError = useMaybeHandleCriticalError();

  return (
    error,
    errorDialogHeaderLangKey,
    errorMapWithPageReload = {},
    errorMapWithoutPageReload = {},
    successCallback = null,
    errorCallback = null,
    callback = null
  ) => {
    if (callback) {
      callback();
    }

    if (!error) {
      if (successCallback) {
        successCallback();
      }

      return;
    }

    const { globalErrors } = error;

    if (maybeHandleCriticalError(globalErrors)) {
      return;
    }

    if (globalErrors.length > 0) {
      const reloadPageOnGlobalErrors = isGlobalErrorsMatchesList(
        globalErrors, Object.keys(errorMapWithPageReload)
      );

      dispatch(actionAddGlobalError({
        text: convertGlobalErrors(
          globalErrors,
          _merge(errorMapWithPageReload, errorMapWithoutPageReload)
        ),
        header: typeof errorDialogHeaderLangKey === 'object'
          ? errorDialogHeaderLangKey
          : { id: errorDialogHeaderLangKey },
        redirectUrl: reloadPageOnGlobalErrors && currentUri,
      }));

      if (reloadPageOnGlobalErrors) {
        return;
      }
    }

    if (errorCallback) {
      errorCallback(error);
    }
  };
};
